import React from "react";
import PropTypes from "prop-types";
import { Endpoints, Loyalty } from "npmlinks-constants";
import { Img, GridColumn, GridRow, GridContainer } from "arv-reactcomponents";

const LoyaltyPointsPopUpBlock = props => {
  const { loyaltyPointsData } = props;
  const image = Endpoints.LOYALTY_GIFT_IMAGE;

  return (
    <div className="nw-loyaltypointspopupblock-wrapper">
      <div className="nw-loyaltypointspopupblock-innerwrap">
        {image ? (
          <div className="nw-loyaltypointspopupblock-imagewrap">
            <Img className="nw-loyaltypointspopupblock-image" src={image} />
          </div>
        ) : null}
        <h3 className="nw-loyaltypointspopupblock-title">
          <span className="nw-loyaltypointspopupblock-subtitle">
            {Loyalty.LOYALTY_SUMMARY_TEXT1}
          </span>
          <span className="nw-loyaltypointspopupblock-subtitle">
            {Loyalty.LOYALTY_SUMMARY_TEXT2}
          </span>{" "}
          <span className="nw-loyaltypointspopupblock-subtitle1">
            {Loyalty.LOYALTY_POINTS_TEXT}
          </span>
        </h3>

        <GridContainer className="nw-loyaltypointspopupblock-table">
          <GridRow>
            {Loyalty.LOYALTY_TABLE_HEADINGS.map((tableHead, index) => (
              <GridColumn
                className="nwc-grid-col-sm nw-block nw-loyaltypointspopupblock-th"
                key={index}
              >
                {tableHead}
              </GridColumn>
            ))}
          </GridRow>

          <div>
            {loyaltyPointsData.map((tableBody, index) => (
              <GridRow key={index}>
                {Object.values(tableBody).map((eachTd, index) => (
                  <GridColumn
                    className="nwc-grid-col-sm nw-block nw-loyaltypointspopupblock-td"
                    key={index}
                  >
                    {eachTd}
                  </GridColumn>
                ))}
              </GridRow>
            ))}
          </div>
        </GridContainer>
      </div>
      <div className="nw-loyaltypointspopupblock-note">
        {Loyalty.LOYALTY_REDEEM_POINTS_TEXT}
      </div>
    </div>
  );
};

LoyaltyPointsPopUpBlock.propTypes = {
  loyaltyPointsData: PropTypes.array.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: LoyaltyPointsPopUpBlock,
  component: LoyaltyPointsPopUpBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/LoyaltyPointsPopUpBlock/index.js